<template>
  <div>
    <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="onclose">
        <div class="modal-container">
          <div class="movie-inner">
            <iframe width="560" height="315" :src="srcUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppModal',
  props: {
    srcUrl: String,
  },
  methods: {
    onclose: function(){
      this.$emit('close');
    },
  },
}
</script>

<style scoped lang="scss">

#modal {
  margin: 3vw;
}
.modal-mask{
  position: fixed;
  display: table;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity 1s ease;
}
.modal-wrapper{
  height: 100%;
  display: flex;
  align-items: center;
  /* background-color: rgba(0, 0, 0, .5); */
}
.modal-container {
  width: 80%;
  max-width: 840px;
  margin: 0 auto;
  // padding: 60px 2vw 80px;
  border: 2px solid #aaa;
  text-align: center;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  /* transition: all .3s ease; */
  @include mq(tb) {
    width: 96%;
    max-width: none;
  }
}

.modal-body {
  margin: 20px 0;
}

.movie-inner{
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  iframe {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
  }

}

/* モーダル開閉時のアニメーション */
.modal-enter-active,
.modal-leave-active {
   transition: all 1s;
}
.modal-enter,
.modal-leave-to{
  opacity: 0;
}
.modal-enter-to,
.modal-leave{
  opacity: 1;
}




</style>
